import { h } from 'preact';
import { joinClasses } from 'utils/utils';

import s from 'components/icons/youtubeIcon.sss';

const YoutubeIcon = ({ currentColor, ...props }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14" {...props} class={joinClasses(s.youtube, currentColor && s.currentColor, props.class)}>
			<rect x="7.72656" y="3.63574" width="6.81818" height="7.27272" />
			<path d="M2.914 0.259822C1.36626 0.381352 0.196216 1.64003 0.12066 3.19116C0.0581601 4.46981 0 5.94028 0 6.95583C0 7.98275 0.0598956 9.47584 0.122396 10.7641C0.197049 12.2953 1.34115 13.5463 2.86795 13.6867C4.55807 13.843 7.00329 14.0001 9.99996 14.0001C12.9886 14.0001 15.4297 13.8439 17.1189 13.6885C18.6518 13.547 19.7977 12.2883 19.8715 10.7509C19.9366 9.39415 20 7.84292 20 6.95581C20 6.07821 19.9375 4.55047 19.8733 3.20403C19.7995 1.64674 18.6267 0.380245 17.0728 0.258689C15.4087 0.127614 13.0095 0 9.99992 0C6.98258 0 4.5788 0.128471 2.91391 0.259556L2.914 0.259822ZM8 3.98716L13.1553 6.95583L8 9.92362V3.98716Z" />
		</svg>
	);
};

export default YoutubeIcon;